import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ActionsPage } from './pages/ActionsPage';
import { ImpactPage } from './pages/ImpactPage';
import { BlogPage } from './pages/BlogPage';
import { ArticlePage } from './pages/ArticlePage';
import { DonatePage } from './pages/DonatePage';
import { PartnerPage } from './pages/PartnerPage';
import { AdminDashboard } from './pages/AdminDashboard';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { FormateursPage } from './pages/FormateursPage';
import { BenevolesPage } from './pages/BenevolesPage';
// ScrollToTop component to ensure page starts at top on navigation
function ScrollToTop() {
  const {
    useLocation
  } = require('react-router-dom');
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function App() {
  return <Router data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <Routes data-id="element-2">
        <Route path="/" element={<HomePage data-id="element-4" />} data-id="element-3" />
        <Route path="/about" element={<AboutPage data-id="element-6" />} data-id="element-5" />
        <Route path="/actions" element={<ActionsPage data-id="element-8" />} data-id="element-7" />
        <Route path="/impact" element={<ImpactPage data-id="element-10" />} data-id="element-9" />
        <Route path="/blog" element={<BlogPage data-id="element-12" />} data-id="element-11" />
        <Route path="/blog/article/:id" element={<ArticlePage data-id="element-14" />} data-id="element-13" />
        <Route path="/donate" element={<DonatePage data-id="element-16" />} data-id="element-15" />
        <Route path="/partner" element={<PartnerPage data-id="element-18" />} data-id="element-17" />
        <Route path="/admin" element={<AdminDashboard data-id="element-20" />} data-id="element-19" />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage data-id="element-22" />} data-id="element-21" />
        <Route path="/formateurs" element={<FormateursPage data-id="element-24" />} data-id="element-23" />
        <Route path="/benevoles" element={<BenevolesPage data-id="element-26" />} data-id="element-25" />
      </Routes>
    </Router>;
}